import { Identifiers, SectionsKey } from "~/constants/enum";

const PageStruct = {
  id: "checkout",
  useLayout: true,
  children: [{ id: SectionsKey.Checkout, order: 1 },
  { id: SectionsKey.CheckoutFooter, order: 2, identifier: Identifiers.CheckoutFooter },
  ],
};

export default PageStruct;
